import { Mail, Instagram, Linkedin, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_bf190b2c-0547-4061-a149-b09b814092c5/artifacts/xou2tw75_Screenshot%202026-05-07%20075825.png"
                alt="KAROBAR Logo"
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Open Sans' }}>KAROBAR</h3>
                <p className="text-xs text-gray-400 tracking-widest">THE ERA OF ENTREPRENEURS</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              The official entrepreneurship club of Christ University, Bangalore. Building the next generation of innovators and leaders.
            </p>
          </div>

          <div>
            <h4 className="text-gold-500 font-bold mb-4 tracking-widest text-sm" style={{ fontFamily: 'Open Sans' }}>QUICK LINKS</h4>
            <div className="space-y-3">
              <Link to="/about" className="block text-gray-400 hover:text-gold-500 transition-colors text-sm" data-testid="footer-about-link">About Us</Link>
              <Link to="/events" className="block text-gray-400 hover:text-gold-500 transition-colors text-sm" data-testid="footer-events-link">Events</Link>
              <Link to="/team" className="block text-gray-400 hover:text-gold-500 transition-colors text-sm" data-testid="footer-team-link">Team</Link>
              <Link to="/partnerships" className="block text-gray-400 hover:text-gold-500 transition-colors text-sm" data-testid="footer-partnerships-link">Partnerships</Link>
            </div>
          </div>

          <div>
            <h4 className="text-gold-500 font-bold mb-4 tracking-widest text-sm" style={{ fontFamily: 'Open Sans' }}>CONNECT WITH US</h4>
            <div className="space-y-3 mb-6">
              <a href="mailto:karobar.dps@christuniversity.in" className="flex items-center space-x-2 text-gray-400 hover:text-gold-500 transition-colors text-sm" data-testid="footer-email-link">
                <Mail size={16} />
                <span>karobar.dps@christuniversity.in</span>
              </a>
              <div className="flex items-center space-x-2 text-gray-400 text-sm">
                <MapPin size={16} />
                <span>Christ University, Bangalore</span>
              </div>
            </div>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/karobar_dps/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold-500 transition-colors" data-testid="footer-instagram-link">
                <Instagram size={20} />
              </a>
              <a href="https://www.linkedin.com/company/karobardps/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold-500 transition-colors" data-testid="footer-linkedin-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 KAROBAR - The Era of Entrepreneurs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;